// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideMaximize as RawLucideMaximize } from "lucide-react";
export const LucideMaximize = /* @__PURE__ */ createIcon(RawLucideMaximize, "LucideMaximize", 2);
